import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { setAuthToken, setRefreshToken } from '../config/api';
import { authApi } from '../services/authApi';
import Layout from '../components/Layout';
import toast from 'react-hot-toast';

const readOAuthTokens = () => {
  const params = new URLSearchParams(window.location.search);
  const hashParams = new URLSearchParams(window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash);

  return {
    access_token: hashParams.get('access_token') || params.get('access_token'),
    refresh_token: hashParams.get('refresh_token') || params.get('refresh_token'),
    provider: params.get('provider') || hashParams.get('provider') || 'google'
  };
};
const AuthCallback = () => {
  const navigate = useNavigate();
  const { fetchUserScans, setUser, setIsAuthenticated } = useAuth();
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        const tokens = readOAuthTokens();
        if (!tokens.access_token) {
          throw new Error('No access token received from OAuth provider');
        }

        const response = await authApi.handleOAuthCallback(tokens);

        window.history.replaceState(null, document.title, window.location.pathname);
        setAuthToken(response.access_token);
        if (response.refresh_token) {
          setRefreshToken(response.refresh_token);
        }

        setUser(response.user);
        setIsAuthenticated(true);

        try {
          await fetchUserScans();
        } catch (scanError) {
          console.warn('Unable to load scans after OAuth login', scanError);
        }

        setStatus('success');
        toast.success('Login successful!');
        setTimeout(() => navigate('/', { replace: true }), 1000);
      } catch (err) {
        console.error('OAuth callback error:', err);
        setStatus('error');
        toast.error(err?.message || 'Authentication failed. Please try again.');
        setTimeout(() => navigate('/login', { replace: true }), 2000);
      }
    };

    handleOAuthCallback();
  }, [navigate, fetchUserScans, setUser, setIsAuthenticated]);

  return (
    <Layout>
      <div className="login-page">
        <div className="login-page__frame">
          <section className="login-card">
            <div className="login-card__surface">
                <div className="login-card__header">
                  <div className={`login-card__badge login-card__badge--oauth login-card__badge--${status}`}>
                    {status === 'processing' && <span className="login-card__status-glyph">..</span>}
                    {status === 'success' && <span className="login-card__status-glyph">OK</span>}
                    {status === 'error' && <span className="login-card__status-glyph">ER</span>}
                  </div>
                <h1 className="login-card__title">
                  {status === 'processing' && 'Authenticating...'}
                  {status === 'success' && 'Success!'}
                  {status === 'error' && 'Authentication Failed'}
                </h1>
                <p className="login-card__subtitle">
                  {status === 'processing' && 'Please wait while we complete your sign-in.'}
                  {status === 'success' && 'Redirecting you to the dashboard...'}
                  {status === 'error' && 'Redirecting you back to login...'}
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default AuthCallback;
